import { atom } from "jotai";

export interface GoogleIma {
  isImaReady: boolean;
}

export const googleImaAtom = atom<GoogleIma>({
  isImaReady: false,
});
